import { ColumnDef } from '@tanstack/react-table';

interface SectorRotationRow {
  index: string;
  trend: number;
  flows: number;
  tactical: number;
  total: number;
  benchmark: number;
  model: number;
  active: number;
}

export const columns: ColumnDef<SectorRotationRow>[] = [
  {
    header: 'Sector',
    accessorKey: 'index',
    enableSorting: false,
  },
  {
    header: 'Trend (TB)',
    accessorKey: 'trend',
  },
  {
    header: 'Flows',
    accessorKey: 'flows',
  },
  {
    header: 'Tactical ML',
    accessorKey: 'tactical',
  },
  {
    header: 'Total',
    accessorKey: 'total',
  },
  {
    header: 'Benchmark Wgt',
    accessorKey: 'benchmark',
  },
  {
    header: 'Model Wgt',
    accessorKey: 'model',
  },
  {
    header: 'Active Wgt',
    accessorKey: 'active',
  },
];
